import * as React from "react";
import type { MenuProps } from "@fluentui/react-components";
import {
  renderMenu_unstable,
  useMenuContextValues_unstable,
} from "@fluentui/react-components";
import { useAppMenu } from "./useAppMenu";

export const AppMenu = React.forwardRef<HTMLDivElement, MenuProps>(
  (props, _ref) => {
    const state = useAppMenu(props);
    const contextValues = useMenuContextValues_unstable(state);
    return renderMenu_unstable(state, contextValues);
  }
);
